import request from '@/utils/request'

export function updateMailCfg(data) {
  return request({
    url: 'api/v1/mail/updateLevelCfg',
    method: 'post',
    data: data
  })
}

export function getMailCfgList(data) {
  return request({
    url: 'api/v1/mail/getList',
    method: 'post',
    data: data
  })
}

export function copyMailCfgList(data) {
  return request({
    url: 'api/v1/mail/copy',
    method: 'post',
    data: data
  })
}

export function delMailCfg(data) {
  return request({
    url: 'api/v1/mail/del',
    method: 'delete',
    data: data
  })
}

